export const CREDENTIALS_REQUEST = 'CREDENTIALS_REQUEST';
export const CREDENTIALS_AVAILABLE = 'CREDENTIALS_AVAILABLE';
export const CREDENTIALS_UNAVAILABLE = 'CREDENTIALS_UNAVAILABLE';
export const CREDENTIALS_STORE = 'CREDENTIALS_STORE';
export const CREDENTIALS_CLEAR = 'CREDENTIALS_CLEAR';

export const SIGN_IN_REQUEST = 'SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';
export const LOG_OUT_REQUEST = 'LOG_OUT_REQUEST';
export const LOG_OUT_SUCCESS = 'LOG_OUT_SUCCESS';
export const LOG_OUT_FAILURE = 'LOG_OUT_FAILURE';

export const STORES_LOADING = 'STORES_LOADING';
export const STORES_FAILURE = 'STORES_FAILURE';
export const STORES_SUCCESS = 'STORES_SUCCESS';
export const SET_STORE = 'SET_STORE';
export const SET_CHAIN = 'SET_CHAIN';
export const CHAIN_LIST = 'CHAIN_LIST';
export const SET_STORE_NAME = 'SET_STORE_NAME';
export const STORE_NAME_LIST = 'STORE_NAME_LIST';
export const SET_STORE_LIST = 'SET_STORE_LIST';

export const CATEGORIES_LOADING = 'CATEGORIES_LOADING';
export const CATEGORIES_SUCCESS = 'CATEGORIES_SUCCESS';
export const CATEGORIES_FAILURE = 'CATEGORIES_FAILURE';
export const CATEGORIES_LIST_LOADING = 'CATEGORIES_LIST_LOADING';
export const SET_CATEGORY = 'SET_CATEGORY';
export const CATEGORY_PROGRESS_SUCCESS = 'CATEGORY_PROGRESS_SUCCESS';
export const CATEGORY_PROGRESS_FAILURE = 'CATEGORY_PROGRESS_FAILURE';

export const HOME_TASKS_LOADING = 'HOME_TASKS_LOADING';
export const HOME_TASKS_SUCCESS = 'HOME_TASKS_SUCCESS';
export const HOME_TASKS_FAILURE = 'HOME_TASKS_FAILURE';

export const TASKS_LIST_LOADING = 'TASKS_LIST_LOADING';
export const TASKS_LIST_SUCCESS = 'TASKS_LIST_SUCCESS';
export const TASK_STATUS_UPDATE = 'TASK_STATUS_UPDATE';
export const TASKS_LIST_FAILURE = 'TASKS_LIST_FAILURE';
export const TASKS_LIST_CLEAR = 'TASKS_LIST_CLEAR';
export const TASKS_LIST_SEARCH = 'TASKS_LIST_SEARCH';
export const TASKS_LIST_SET_SEARCH = 'TASKS_LIST_SET_SEARCH';
export const MORE_TASKS_LOADING = 'MORE_TASKS_LOADING';
export const PROGRESS_LOADING = 'PROGRESS_LOADING';
export const PROGRESS_SUCCESS = 'PROGRESS_SUCCESS';
export const RESOURCE_SUCCESS = 'RESOURCE_SUCCESS';
export const RESOURCE_REPORT_SUCCESS = 'RESOURCE_REPORT_SUCCESS';
export const PROGRESS_FAILURE = 'PROGRESS_FAILURE';
export const PROGRESS_COUNT = 'PROGRESS_COUNT';
export const ICONS = 'ICONS';
export const REPORT_ICONS = 'REPORT_ICONS';
export const REPORT_SUCCESS = 'REPORT_SUCCESS';
export const REPORT_FAILURE = 'REPORT_FAILURE';
export const REPORT_LOADING = 'REPORT_LOADING';

export const TASKS_STATUS_LOADING = 'TASKS_STATUS_LOADING';
export const TASKS_STATUS_SUCCESS = 'TASKS_STATUS_SUCCESS';
export const TASKS_STATUS_FAILURE = 'TASKS_STATUS_FAILURE';

export const CURRENT_TASKS_TYPE = 'CURRENT_TASKS_TYPE';
export const UPDATE_SUPPLIER = 'UPDATE_SUPPLIER';
export const RESET_SUPPLIER = 'RESET_SUPPLIER';

export const IMAGES_LOADING = 'IMAGES_LOADING';
export const IMAGES_SUCCESS = 'IMAGES_SUCCESS';
export const IMAGES_FAILURE = 'IMAGES_FAILURE';
export const BARCODE_SUCCESS = 'BARCODE_SUCCESS';
export const BARCODE_FAILURE = 'BARCODE_FAILURE';

export const AISLES_LOADING = 'AISLES_LOADING';
export const AISLES_SUCCESS = 'AISLES_SUCCESS';
export const AISLES_FAILURE = 'AISLES_FAILURE';
export const AISLES_BY_TASKS_SUCCESS = 'AISLES_BY_TASKS_SUCCESS';
export const AISLES_LIST_SEARCH = 'AISLES_LIST_SEARCH';
export const AISLES_LAYOUT_SUCCESS = 'AISLES_LAYOUT_SUCCESS';

export const RESOURCES_OVERHEAD_LOADING = 'RESOURCES_OVERHEAD_LOADING';
export const RESOURCES_OVERHEAD_SUCCESS = 'RESOURCES_OVERHEAD_SUCCESS';
export const RESOURCES_OVERHEAD_FAILURE = 'RESOURCES_OVERHEAD_FAILURE';

export const RESOURCES_TASK_DETAILS_FEATURES_LOADING =
  'RESOURCES_TASK_DETAILS_FEATURES_LOADING';
export const RESOURCES_TASK_DETAILS_FEATURES_SUCCESS =
  'RESOURCES_TASK_DETAILS_FEATURES_SUCCESS';
export const RESOURCES_TASK_DETAILS_FEATURES_FAILURE =
  'RESOURCES_TASK_DETAILS_FEATURES_FAILURE';

export const UPDATE_FILTER = 'UPDATE_FILTER';
export const UPDATE_PREV_FILTER = 'UPDATE_PREV_FILTER';
export const CREATE_FILTER_LIST = 'CREATE_FILTER_LIST';

export const SNACK_SET = 'SNACK_SET';

export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';
export const CUSTOM_SNACKBAR = 'CUSTOM_SNACKBAR';
export const SNACKBAR_SUCCESS = 'SNACKBAR_SUCCESS';
export const SNACKBAR_ERROR = 'SNACKBAR_ERROR';
export const SNACKBAR_WARNING = 'SNACKBAR_WARNING';
export const SNACKBAR_INFO = 'SNACKBAR_INFO';

export const SHOW_FLOATING_BUTTON = 'SHOW_FLOATING_BUTTON';
export const HIDE_FLOATING_BUTTON = 'HIDE_FLOATING_BUTTON';
export const OPEN_MENU = 'OPEN_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';

export const NAVIGATION_STATUS = 'NAVIGATION_STATUS';
export const NAVIGATION_LOADING = 'NAVIGATION_LOADING';
export const NAVIGATION_COMPLETED = 'NAVIGATION_COMPLETED';
export const NAVIGATION_PENDING = 'NAVIGATION_PENDING';
export const NAVIGATION_LAST = 'NAVIGATION_LAST';
export const NAVIGATION_FAILURE = 'NAVIGATION_FAILURE';
export const NAVIGATION_PROGRESS = 'NAVIGATION_PROGRESS';
export const NAVIGATION_ACCESS = 'NAVIGATION_ACCESS';

export const SEARCH_LOADING = 'SEARCH_LOADING';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const UPDATE_REPORT_PARAMETERS = 'UPDATE_REPORT_PARAMETERS';
export const SEARCH_FILTER_LIST = 'SEARCH_FILTER_LIST';
export const RESET_FILTER_LIST = 'RESET_FILTER_LIST';
export const RESET_SEARCH_LIST = 'RESET_SEARCH_LIST';
export const RESTORE_SEARCH_LIST = 'RESTORE_SEARCH_LIST';
export const SWITCH_VIEW = 'SWITCH_VIEW';

export const REPORT_OPTIONS_LOADING = 'REPORT_OPTIONS_LOADING';
export const REPORT_OPTIONS_SUCCESS = 'REPORT_OPTIONS_SUCCESS';
export const REPORT_OPTIONS_FAILURE = 'REPORT_OPTIONS_FAILURE';

export const SCANNER_ACCESS_LOADING = 'SCANNER_ACCESS_LOADING';
export const SCANNER_ACCESS_SUCCESS = 'SCANNER_ACCESS_SUCCESS';
export const SCANNER_ACCESS_FAILURE = 'SCANNER_ACCESS_FAILURE';


export const PRODUCTS_LOADING = 'PRODUCTS_LOADING';
export const PRODUCTS_SUCCESS = 'PRODUCTS_SUCCESS';
export const PRODUCTS_FAILURE = 'PRODUCTS_FAILURE';
export const ADJUSMENT_PLACEMENT_SUCCESS = 'ADJUSMENT_PLACEMENT_SUCCESS';
export const LAST_CAPTURE_LOADING = 'LAST_CAPTURE_LOADING';
export const LAST_CAPTURE_SUCCESS = 'LAST_CAPTURE_SUCCESS';
export const LAST_CAPTURE_FAILURE = 'LAST_CAPTURE_FAILURE';

export const USERS_LOADING = 'USERS_LOADING';
export const USERS_SUCCESS = 'USERS_SUCCESS';
export const USERS_FAILURE = 'USERS_FAILURE';
export const USERS_UPDATE_SUCCESS = 'USERS_UPDATE_SUCCESS';
export const USERS_UPDATE_FAILURE = 'USERS_UPDATE_FAILURE';
export const SET_SUPPLIER = 'SET_SUPPLIER';
export const SUPPLIER_LOADING = 'SUPPLIER_LOADING';
export const PASSWORD_LOADING = 'PASSWORD_LOADING';
export const PASSWORD_REJECTED = 'PASSWORD_REJECTED';
export const PASSWORD_SUCCESS = 'PASSWORD_SUCCESS';
export const PASSWORD_FAILURE = 'PASSWORD_FAILURE';
export const PASSWORD_UPDATE = 'PASSWORD_UPDATE';

export const TICKETS_LOADING = 'TICKETS_LOADING';
export const TICKETS_SUCCESS = 'TICKETS_SUCCESS';
export const TICKETS_FAILURE = 'TICKETS_FAILURE';
export const CREATE_TICKETS_LOADING = 'CREATE_TICKETS_LOADING';
export const CREATE_TICKETS_SUCCESS = 'CREATE_TICKETS_SUCCESS';
export const CREATE_TICKETS_FAILURE = 'CREATE_TICKETS_FAILURE';

export const EXCEL_DATA_LOADING = 'EXCEL_DATA_LOADING';
export const EXCEL_DATA_SUCCESS = 'EXCEL_DATA_SUCCESS';
export const EXCEL_DATA_FAILURE = 'EXCEL_DATA_FAILURE';

export const MESSAGES_SUCCESS = 'MESSAGES_SUCCESS';
export const MESSAGES_FAILURE = 'MESSAGES_FAILURE';
export const MESSAGES_LOADING = 'MESSAGES_LOADING';

export const BRANDS_SUCCESS = 'BRANDS_SUCCESS';
export const BRANDS_FAILURE = 'BRANDS_FAILURE';
export const BRANDS_LOADING = 'BRANDS_LOADING';

export const NETWORK_LOADING = 'NETWORK_LOADING';
export const NETWORK_SUCCESS = 'NETWORK_SUCCESS';
export const NETWORK_FAILURE = 'NETWORK_FAILURE';
export const NETWORK_EXTRA_METADATA_UPDATE = 'NETWORK_EXTRA_METADATA_UPDATE';

export const VIEWS_LOADING = 'VIEWS_LOADING';
export const VIEWS_SUCCESS = 'VIEWS_SUCCESS';
export const VIEWS_FAILURE = 'VIEWS_FAILURE';